import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";

import {ConversationViewPagination} from "../conversation-view-pagination.tsx";
import {TableViewPagination} from "../table-view-pagination.tsx";

interface Props {
    /**
     * Show the new table view instead of the conversations view
     */
    renderTableView?: boolean;
    /**
     * The current cursor from URL params
     */
    cursor?: string;
    /**
     * The cursor result from the query
     */
    cursorResult: string | null | undefined;
    /**
     * The current pathname
     */
    pathname: string;
}

/**
 * Renders the appropriate pagination component based on view type.
 */
const GuideTranscriptsPagination = ({
    renderTableView,
    cursor,
    cursorResult,
    pathname,
}: Props): React.ReactNode => {
    if (renderTableView) {
        return (
            <TableViewPagination
                cursor={cursor}
                cursorResult={cursorResult}
                pathname={pathname}
            />
        );
    }

    return (
        <>
            <View style={styles.mediumSpacing} />
            <ConversationViewPagination
                cursor={cursor}
                cursorResult={cursorResult}
                pathname={pathname}
            />
        </>
    );
};

export {GuideTranscriptsPagination};

const styles = StyleSheet.create({
    mediumSpacing: {
        height: sizing.size_100,
    },
});
